import { Dispatch, SetStateAction, useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";

import { User } from "../../Utils/Types";
import google from "../../Assets/Images/google.svg";

const Login = ({
	setAuthenticatedUser,
	setUserIsAuthenticated,
}: {
	authenticatedUser: User | null;
	setAuthenticatedUser: Dispatch<SetStateAction<User | null>>;
	setUserIsAuthenticated: Dispatch<SetStateAction<boolean>>;
}) => {
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);

	const AuthenticatedUser = async (email: string) => {
		try {
			if (!email) throw new Error("Email not provided");
			const res = await fetch(
				process.env.REACT_APP_AUTHENTICATE_BASE_URL + "users/authenticate",
				{
					method: "POST",
					body: JSON.stringify({ email }),
					headers: {
						"Content-Type": "application/json",
						"app-auth-token": process.env.REACT_APP_APP_AUTH_TOKEN!,
					},
					cache: "force-cache",
				}
			);
			if (!res.ok) throw new Error("Error: Unable to authenticate user");
			const authenticate = await res.json();
			if (authenticate?.code === 200) {
				const { data }: { data: User } = authenticate;
				// sessionStorage.setItem("userId", data?._id);
				// sessionStorage.setItem("userName", data?.name);
				// sessionStorage.setItem("isDeveloper", `${data?.isDeveloper}`);
				// sessionStorage.setItem("nickName", data?.nick_name);
				sessionStorage.setItem("isAuthenticated", "true");
				sessionStorage.setItem("authenticatedUser", JSON.stringify(data));
				setAuthenticatedUser(data);
				setUserIsAuthenticated(true);
			} else throw new Error("Error: Unable to authenticate user");
		} catch (error) {
			setLoading(false);
		}
	};
	const fetchUserInfo = async (accessToken: string) => {
		try {
			// Production
			const response = await fetch(
				"https://www.googleapis.com/oauth2/v3/userinfo",
				{
					method: "GET",
					headers: {
						Authorization: `Bearer ${accessToken}`,
					},
				}
			);
			if (!response.ok)
				throw new Error(`Error: ${response.status} - ${response.statusText}`);
			const data = await response.json();
			AuthenticatedUser(data?.email);

			// Staging
			// AuthenticatedUser("irum.ishfaq@discretelogix.com");
		} catch (error) {
			console.error("Failed to fetch user info:", error);
			setLoading(false);
		}
	};

	const login = useGoogleLogin({
		onSuccess: async ({ access_token }: { access_token: string }) => {
			fetchUserInfo(access_token);
		},
		onError: () => {
			console.log("Login Failed");
			setError("Google login failed. Please try again.");
			setLoading(false);
		},
	});

	const handleLogin = () => {
		setLoading(true);
		setError(null);
		login();
		// fetchUserInfo("");
	};

	return (
		<div className='w-screen h-screen flex flex-row relative bg-[#242933]'>
			<div className='flex flex-col justify-center items-start my-auto w-fit h-full m-auto'>
				<h2 className='text-[#0a84fe] text-3xl font-sans mb-4'>Welcome To</h2>
				<h1 className='text-white text-5xl font-semibold font-sans'>Lead</h1>
				<h1 className='text-white text-5xl font-semibold font-sans'>
					Management
				</h1>
				<h1 className='text-white text-5xl font-semibold font-sans'>System</h1>

				{!loading ? (
					<button
						className='w-72 h-16 mt-16 bg-white rounded-xl flex flex-row justify-center items-center gap-4'
						onClick={handleLogin}
					>
						<img src={google} alt='google' className='size-7' />
						<h3 className='text-black font-sans text-xl'>
							Sign In with Google
						</h3>
					</button>
				) : (
					<button
						type='button'
						className='w-72 h-16 mt-16 bg-gray-200 rounded-xl flex flex-row justify-center items-center gap-4 text-lg cursor-not-allowed'
						disabled
					>
						<svg
							aria-hidden='true'
							className='inline w-8 h-8 text-gray-400 animate-spin dark:text-gray-600 fill-themeColor'
							viewBox='0 0 100 101'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<path
								d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
								fill='currentColor'
							/>
							<path
								d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
								fill='currentFill'
							/>
						</svg>
						Signing in...
					</button>
				)}

				{error && <span className='mt-2 ml-2 text-red-600'>{error}</span>}
			</div>
		</div>
	);
};

export default Login;
